import AndroidConnector from './androidConnector';
import BaseConnector from './baseConnector';
import IOSConnector from './iosConnector';

let platform = null;

export const isCurrentPlatformIOS = () =>
  !(
    typeof window === 'undefined' ||
    typeof window.webkit === 'undefined' ||
    typeof window.webkit.messageHandlers === 'undefined' ||
    typeof window.webkit.messageHandlers.iOS === 'undefined' ||
    typeof window.webkit.messageHandlers.iOS.postMessage !== 'function'
  );

export const isCurrentPlatformAndroid = () =>
  !(typeof window === 'undefined' || typeof window.Android === 'undefined');

export const getCurrentPlatform = () => platform;

export const setNativeStatusBarColor = (color) => {
  platform.setStatusBarColor(color);
};

export const setNativeNavigationBarColor = (color) => {
  platform.setNavigationBarColor(color);
};

export const setNativeModalOpened = (modalOpenedData) => {
  platform.setModalOpened(modalOpenedData);
};

export const setNativeModalClosed = () => {
  platform.setModalClosed();
};

export const onVisitCartNativeHandler = (currentFullRoute) => {
  platform.onVisitCart(currentFullRoute);
};

export const onUpdateCartNativeHandler = (cartFullRoute) => {
  platform.onUpdateCart(cartFullRoute);
};

export const awayFromCartNativeHandler = (currentFullRoute) => {
  platform.awayFromCart(currentFullRoute);
};

export const onClearCartNativeHandler = (currentFullRoute) => {
  platform.onClearCart(currentFullRoute);
};

export const getVisitorDetailsNativeHandler = (tokenValidation) => {
  platform.getVisitorDetails(tokenValidation);
};

(function () {
  if (isCurrentPlatformIOS()) {
    platform = new IOSConnector();
    return;
  }

  if (isCurrentPlatformAndroid()) {
    platform = new AndroidConnector();
    return;
  }

  platform = new BaseConnector();
})();
